import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { NgSwitch } from '@angular/common';
import { ActivatedRoute, Router, Routes, RouterModule } from '@angular/router';
import { OwlCarousel } from 'ngx-owl-carousel';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
import { Title }     from '@angular/platform-browser';

@Component({
  selector: 'app-singlechannel',
  templateUrl: './singlechannel.component.html',
  styleUrls: ['./singlechannel.component.scss']
})
export class SingleChannelComponent {
  channelID: string;
  siteID = environment.siteID;
  isHeadStart = environment.isHeadStart;
  renderStatic = environment.renderStatic;
  viewMode = 'explore';
  searchMode = false;
  constructor(private titleService: Title, public ngxSmartModalService: NgxSmartModalService, private spinner: NgxSpinnerService, private route: ActivatedRoute,private location: Location, private router: Router, public http: HttpClient) { this.ping(), this.videos() }
  channel: any = [];
  singlePlaylist:boolean = false;
  tag: any;
  myData: any;
  doi = environment['doi'];
  searchResult = false;
  subChannel:boolean;
  subSite:boolean;
  bouquetUser:boolean;
  searchString: any;
  playlists: any = [];
  playlistID: any;
  sliderOptions = { dots: false, navigation: true, nav: false, autoplay: false, loop: false, autoplayTimeout: 2000, autoplayHoverPause: true, lazyLoad: true, responsive: { 0: { items: 1 }, 600: { items: 2 }, 960: { items: 4 }, 1200: { items: 4 } } };
  contents: any;
  contentVideos: any;
  contentsSearch = [];
  content: any;
  channels:any;
  channelsSearch:any;
  loaded:boolean = false;
  channelLoaded:boolean = false;
  videosLoaded:boolean = false;
  playlist: any;
  playlistsSearch: any;
  updateRoute(to){
    let url = this.location.path().replace(this.viewMode, to);
      this.location.go(url);
    }
  public ping() {
    console.log('isHeadStart', this.isHeadStart);
    this.route.params.subscribe(params2 => {
      this.channelLoaded = false;
      this.channelID = params2['channelID'];
      this.viewMode = params2['tab'];
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      let callURL = 'https://api-staging.videyo.tv/endpoint/getChannel?siteID='+this.siteID+'&depth=2&channelID=' + this.channelID
      if(this.renderStatic) {
        https://staticsitecacher.s3.us-east-2.amazonaws.com
        callURL = 'https://json.videyo.tv//'+this.siteID+'/getChannel/'+this.channelID+'/fullData.json?salt='+(new Date().toISOString().slice(0,13))
      }
       this.http.get(callURL, {
     headers: myheader
      })
        .subscribe(
          dataholder => {
            let data = dataholder
            if(this.renderStatic) {
             data = dataholder['data']
            }
            this.channel = data;
            this.titleService.setTitle( this.channel['name'] );
            this.playlists = data['playlists'];
            if (this.playlists.length < 2) { 
              this.viewMode = 'videos';
            }
            this.subChannel = this.channel.userSubscribed;
            this.subSite = this.channel.subscribedToSite;
            this.bouquetUser = this.channel.withBouquet;
            if (!(this.subChannel == true || (this.subSite == true&&this.bouquetUser == true))) { 
              this.ngxSmartModalService.create('subscribe', '').open();
            }
            this.channelLoaded = true;
                      
            
          },
          error => {
            if (error.status >= 400 && error.status < 500) { 
              this.ngxSmartModalService.create('subscribe', '').open();
            }
         else if (error.status >= 500) { 
location.reload();
        }
            console.log('ERROR:');
            console.log(error);
          }
        );
    });
  }
  public videos() {
    this.route.params.subscribe(params2 => {
      this.channelID = params2['channelID'];
      this.viewMode = params2['tab'];
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      let callURL = 'https://api-staging.videyo.tv/endpoint/getChannel?siteID='+this.siteID+'&depth=4&channelID=' + this.channelID
      if(this.renderStatic) {
        https://staticsitecacher.s3.us-east-2.amazonaws.com
        callURL = 'https://json.videyo.tv//'+this.siteID+'/getChannel/'+this.channelID+'/fullData.json?salt='+(new Date().toISOString().slice(0,13))
      }
       this.http.get(callURL, {
     headers: myheader
      })
        .subscribe(
          dataholder => {
            let data = dataholder
            if(this.renderStatic) {
             data = dataholder['data']
            }
            this.contents = [];
            this.playlists = data['playlists'];
            this.playlists.forEach(playlist => {
              playlist.contents.forEach(content => {
                this.contents.push(content);
              });

            });
            this.videosLoaded = true;
          },
          error => {
            if (error.status >= 400 && error.status < 500) { 
              this.ngxSmartModalService.create('subscribe', '').open();
            }
         else if (error.status >= 500) { 
this.videosLoaded = false;
        }
            console.log('ERROR:');
            console.log(error);
          }
          );
        });
          }
  public favourite(contentId, playlistId) {
    this.route.params.subscribe(params2 => {
      this.channelID = params2['channelID'];
      this.viewMode = params2['tab'];
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    
    this.http.get('https://api-staging.videyo.tv/endpoint/makeFavorite?channelID='+this.channelID+'&siteID='+this.siteID+'&playlistID='+playlistId+'&contentId='+contentId,{
      headers:myheader
    })
    .subscribe(
      data => {
       
      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('subscribe', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
  );
});
  }
  public myList(contentId, playlistId){
    this.route.params.subscribe(params2 => {
      this.channelID = params2['channelID'];
      this.viewMode = params2['tab'];
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  
  this.http.get('https://api-staging.videyo.tv/endpoint/addToMyList?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
    headers:myheader
  })
  .subscribe(
    data => {  
    },
    error => {
      if (error.status >= 400 && error.status < 500) { 
        this.ngxSmartModalService.create('subscribe', '').open();
      }
      else if (error.status >= 500) { 
        this.ngxSmartModalService.create('myModal2', '').open();
        
      }
      console.log('ERROR:');
      console.log(error);
    }
);
    });
  }
  public watchLater(contentId, playlistId){
    this.route.params.subscribe(params2 => {
      this.channelID = params2['channelID'];
      this.viewMode = params2['tab'];
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  
  this.http.get('https://api-staging.videyo.tv/endpoint/addToWatchLater?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
    headers:myheader
  })
  .subscribe(
    data => {
    
    },
    error => {
      if (error.status >= 400 && error.status < 500) { 
        this.ngxSmartModalService.create('subscribe', '').open();
      }
      else if (error.status >= 500) { 
        this.ngxSmartModalService.create('myModal2', '').open();
        
      }
      console.log('ERROR:');
      console.log(error);
    }
);
    });
  }
  onSiteSearchKeyUp(event:any){
    this.searchString = event.target.value;
   
  }
  siteSearch(){
    this.searchMode = true;
    this.searchResult = true;
    this.viewMode = 'search';
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      this.http.get('https://api-staging.videyo.tv/endpoint/searchChannel?siteID='+this.siteID+'&channelID='+this.channelID+'&searchString='+this.searchString, {
        headers: myheader
      })
      .subscribe(
        data => {
          if (data === undefined) {
            this.searchResult = false;
          }
          else {
              this.contentsSearch = data['contents'];
              this.searchResult = true;
          }
        },
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('subscribe', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
      );
  }
  refresh(): void {
    window.location.reload();
}
  hideSearch() {
    this.searchMode = false;
  }
  ngOnInit() {
    /** spinner starts on init */
    this.spinner.show();
  
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
  }, 1500);
  }
  ngAfterViewChecked() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.loaded = true;
    }, 1500);
  }
}

